import {CALL_API} from '../../middleware/api'
import queryString from 'query-string'

// 待办任务
export const TASK_ASSIGNEE_REQUEST = 'TASK_ASSIGNEE_REQUEST'
export const TASK_ASSIGNEE_SUCCESS = 'TASK_ASSIGNEE_SUCCESS'
export const TASK_ASSIGNEE_FAILURE = 'TASK_ASSIGNEE_FAILURE'

export const TASK_ASSIGNEE_MUTATIONS = 'TASK_ASSIGNEE_MUTATIONS'

// page = 1 & size = 10
export function getAssignee(params) {
	return {
		[CALL_API]: {
			types: [TASK_ASSIGNEE_REQUEST, TASK_ASSIGNEE_SUCCESS, TASK_ASSIGNEE_FAILURE],
			endpoint: `/workflow/task/assignee?` + queryString.stringify(params),
		}
	};
}

export function taskAssigneeMutations(payload) {
	return {
		type: TASK_ASSIGNEE_MUTATIONS,
    payload
	}
}

export default (params) => {
	return (dispatch, getState) => {
		return dispatch(getAssignee(params))
	};
};


// WEBPACK FOOTER //
// ./src/action/workflow/assignee.js